module.exports = __webpack_public_path__ + "static/media/ic_edit_photo.febf8c39.svg";